import {
  Component,
  OnInit,
  inject,
  input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import { ButtonDirective } from "primeng/button";

import { ProgressModel } from "./progress.model";
import { onboarding } from "./onboarding.const";
import { User } from "../../user/user.model";
import { role } from "../../user/role.const";
import { UserRepository } from "../../user/user.repository";
import { QuoteRepository } from "../../quote/quote.repository";
import { NotifyService } from "../../notify/notify.service";
import { eventType } from "../../notify/event.const";
import { EventService } from "../../shared/event/event.service";

@Component({
  selector: "app-user-progress",
  templateUrl: "./user-progress.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./user-progress.component.scss"],
  imports: [ButtonDirective],
})
export class UserProgressComponent implements OnInit {
  private userRepository = inject(UserRepository);
  private router = inject(Router);
  private quoteRepository = inject(QuoteRepository);
  private notifyService = inject(NotifyService);
  private eventService = inject(EventService);

  public readonly user = input<User>(undefined);
  public onboarding = onboarding;
  public isShrinked = true;
  public role = role;
  public progress: ProgressModel;

  ngOnInit() {
    this.eventService.eventBus.subscribe((incoming) => {
      if (incoming.event === eventType.userProgressToggle) {
        this.toggle();
      }
    });
    this.userRepository.getProgress().subscribe((progressResponse) => {
      this.progress = ProgressModel.from({ ...progressResponse });
      if (!this.progress.isDone()) {
        this.isShrinked = false;
      }
    });
  }

  public getProgressKeys(): string[] {
    return Object.keys(this.progress);
  }
  public getOnboardingKeys(): string[] {
    return Object.keys(this.progress);
  }
  public stepKeysEqual(): boolean {
    return this.getProgressKeys() === this.getOnboardingKeys();
  }

  public callMethod(method: string): void {
    if (!method) {
      return;
    }
    this[method]();
  }

  public isStepDisabled(stepIndex: number): boolean {
    return !this.user().hasRole(role.pricingManager) && stepIndex > 2;
  }

  public toggle() {
    this.isShrinked = !this.isShrinked;
  }

  private openClientAddForm() {
    this.router.navigate(["client/0/dashboard"]);
  }

  private openQuoteForm() {
    this.router.navigate(["/quote/0"]);
  }

  private goToRates() {
    this.navigateTo("rate/list", null);
  }

  private navigateTo(link: string, queryParams = { openFormOnInit: true }) {
    this.router.navigate([link], {
      replaceUrl: true,
      queryParams,
    });
  }
}
